import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { PageInfo } from 'src/app/core/models/page-info';
import { FreightSearchResult } from 'src/app/core/models/transport-operation/freight-search-result';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { MaterialDocumentService } from '../../services/material-document.service';


@Component({
  selector: 'laas-material-document',
  templateUrl: './material-document.component.html',
  styleUrls: ['./material-document.component.scss']
})
export class MaterialDocumentComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: any = PermissionConstants.ViewFreightSearch;
  readonly helpPermissionCode: string = PermissionConstants.ViewMaterialDocumentSearch;
  currentLang: string = this.laasSetting.language;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "createDt",
    direction: -1
  };

  searchForm: FormGroup;
  tableColumns: DateTableColumn[];
  searchResults: FreightSearchResult[] = [];

  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;

  @ViewChild('createDt') createDt!: CalendarComponent;
  @ViewChild('dataTable') dataTable!: DataTableComponent;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private materialDocumentService:MaterialDocumentService,
    private dropdownOptionsService: DropdownOptionsService
  ) {
    super(injector);

    this.searchForm = this.fb.group({
      laasDoNumber:null,
      plant:null,
      materialDocumentYear:null,
      materialDocumentNumber:[],
      transactionTime:null,
      transactionDate:null,
      createDtStart: null,
      createDtEnd: null
    });

    this.tableColumns = [
      { field: 'laasDoNumber', header: 'MaterialSearch.MainTable.LaasDoNumber', sort: true },
      { field: 'materialDocumentYear', header: 'MaterialSearch.MainTable.MaterialDocumentYear', sort: true },
      { field: 'materialDocumentNumber', header: 'MaterialSearch.MainTable.MaterialDocumentNumber', sort: true },
      { field: 'plant', header: 'MaterialSearch.MainTable.Plant', sort: true },
      { field: 'transactionDate', header: 'MaterialSearch.MainTable.TransactionDate', sort: true },
      { field: 'transactionTime', header: 'MaterialSearch.MainTable.TransactionTime', sort: true },
      { field: 'sequenceId', header: 'MaterialSearch.MainTable.SequenceId', sort: true },
      { field: 'source', header: 'MaterialSearch.MainTable.Source', sort: true },
      { field: 'messageType', header: 'MaterialSearch.MainTable.MessageType', sort: true },
      { field: 'processMessage', header: 'MaterialSearch.MainTable.ProcessMessage', sort: true },
      { field: 'createDt', header: 'MaterialSearch.MainTable.CreateDt', sort: true }
      ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchClickBtn();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchClickBtn();
  }

  searchClickBtn(): void {
    const params = deepCopy(this.searchForm.value);
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    this.dataTable.setCurrentPage(0);
    this.isSearchFormOpen = false;
    this.isLoading = true;

    this.materialDocumentService.searchMaterialDocument(params)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: (result) => {
          this.searchResults = result.content;
          this.pageInfo.totalRecords = result.totalElements;
          this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (err: any) => {
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.dataTable.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        },
        complete:()=>{
          this.isLoading = false;
        }
      });
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'createDt':
        this.searchForm.controls.createDtStart.setValue(date.startDate);
        this.searchForm.controls.createDtEnd.setValue(date.endDate);
        break;
    }
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  resetClickBtn(): void {
    this.createDt.ngOnInit();
    this.searchForm.reset({
      createDtStart: null,
      createDtEnd: null
    });
  }
}
